import React, { useState, useEffect } from "react";
import AddProfilesGridModel from "../../../models/company/addProfiles/response/AddProfilesGridModel";
import AddProfilesInterviewRoundsModel from "../../../models/company/addProfiles/response/AddProfilesInterviewRoundsModel";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import TableContainer from "@mui/material/TableContainer";
import TableSortLabel from "@mui/material/TableSortLabel";
import TableHead from "@mui/material/TableHead";
import { Button } from "@mui/material";

interface ScheduleInterviewRoundsProps {
    objAddProfile: AddProfilesGridModel;
    interviewRoundsList: AddProfilesInterviewRoundsModel[];
    onCloseInterviewRounds: () => void;
    onInterviewRoundSelect: (objInterviewRound: AddProfilesInterviewRoundsModel, objAddProfile: AddProfilesGridModel) => void;
    onInterviewRatingDetails: (objInterviewRound: AddProfilesInterviewRoundsModel, objAddProfile: AddProfilesGridModel) => void;
}

const ScheduleInterviewRoundsComponent = (props: ScheduleInterviewRoundsProps) => {

    const scheduleInterview = (row: AddProfilesInterviewRoundsModel) => {
        props.onInterviewRoundSelect(row, props.objAddProfile);
    };

    const reScheduleInterview = (row: AddProfilesInterviewRoundsModel) => {
        props.onInterviewRoundSelect(row, props.objAddProfile);
    };

    const ratingDetails = (row: AddProfilesInterviewRoundsModel) => {
        props.onInterviewRatingDetails(row, props.objAddProfile);
    };

    const columnsInterviewRound = [
        { key: "roundName", text: "Interview Rounds", sort: false, searchable: false },
        { key: "interviewDate", text: "Interview Date", sort: false, searchable: false },
        { key: "MeetingURL", text: "Meeting Link", sort: false, searchable: false },
        { key: "totalRating", text: "Rating", sort: false, searchable: false },
        { key: "Actions", text: "", sort: false, searchable: false }
    ];

    return (
        <div className="row">
            <div className="col-md-12">
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {columnsInterviewRound.map((column: any) => (
                                    <TableCell key={column.key} className="table-header-cell">
                                        <span>{column.text}</span>
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.interviewRoundsList.map((row: AddProfilesInterviewRoundsModel, index) => (
                                <TableRow>
                                    <TableCell>{row.roundName}</TableCell>
                                    <TableCell>{row.interviewDate}</TableCell>
                                    <TableCell><a href={row.meetingURL} target="_blank" title={row.meetingURL}>Join Meeting</a></TableCell>
                                    <TableCell>{row.totalRating}</TableCell>
                                    <TableCell>
                                        <Button variant="contained" color="primary" onClick={() => { scheduleInterview(row); }} disabled={!row.isEnabled}>
                                            Schedule
                                        </Button>
                                        {row.isActive &&
                                            <Button variant="contained" color="primary" onClick={() => { reScheduleInterview(row); }}>
                                                Re Schedule
                                            </Button>
                                        }
                                        {row.isRated &&
                                            <Button variant="contained" color="primary" onClick={() => { ratingDetails(row); }}>
                                                Rating
                                            </Button>
                                        }
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
    );
};
export default ScheduleInterviewRoundsComponent;